<template>
  <div>
    <div class="sideBarHeader notification-sidebar-header">
      <h5 class="title-sidebar">Thông báo</h5>
      <div class="notification-more-btn-wrap" @click.stop>
        <button
          ref="readAllBtn"
          type="button"
          class="notification-more-btn"
          v-popover:notificationMoreMenu
          @click.stop
          aria-haspopup="true"
          aria-label="Tùy chọn thông báo"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="5" cy="12" r="2" fill="currentColor"/>
            <circle cx="12" cy="12" r="2" fill="currentColor"/>
            <circle cx="19" cy="12" r="2" fill="currentColor"/>
          </svg>
        </button>
        <popover name="notificationMoreMenu" class="text-400-medium notification-more-popover" @click.stop>
          <div class="createChat createMessagePrivate cursor-pointer p-10px" @click="readAllNotification">
            <span>Đánh dấu tất cả là đã đọc</span>
          </div>
        </popover>
      </div>
    </div>
    <div class="cs-tab-menu pl-15px pr-15px mb-15px">
      <div class="text-400-medium cursor-pointer" :class="{ active: tabActive == 1 }" @click="chosenTab(1)">Tất cả</div>
      <div class="text-400-medium cursor-pointer" :class="{ active: tabActive == 2 }" @click="chosenTab(2)">Chưa đọc</div>
    </div>
    <div class="content-sidebar notification-sidebar-content">
      <vue-element-loading :active="isLoading" spinner="bar-fade-scale"/>
      <vue-loadmore
          :on-loadmore="onLoad"
          :finished="finished"
          :loading-text="'Đang tải'"
          :finished-text="'Hết'">
        <div class="notification" v-for="notification of notifications" :key="notification.id">
          <div @click="onClickNotification(notification)">
            <router-link :to="notification.url"
                         :class="{'is_read': notification.is_read }"
                         class="cursor-pointer"
                         @click.native="reloadMessengerFromNotification(notification)">
              <md-list-item class="p-0px m-0px">
                <div class="p-relative read-badge">
                  <md-avatar>
                    <image-template
                      class="notification-avatar"
                      :size="'small'"
                      :image="notificationAvatarImage(notification)"
                      :name="notificationAvatarLabel(notification)"
                    />
                  </md-avatar>
                  <md-badge v-if="!notification.is_read" class="md-primary p-absolute"></md-badge>
                </div>
                <div class="message text-300-default">
                  <template v-if="notification.type == NOTIFICATION_TYPE.ADD_MEMBER">Bạn đã được <span
                      class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span>
                    thêm vào <span class="text-300-medium">{{
                        detectData(notification.data).group ? detectData(notification.data).group.name : ''
                      }}</span>
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.CREATE_POST">
                    <span class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span> đã đăng bài
                    vào <span class="text-300-medium">{{
                      detectData(notification.data).group ? detectData(notification.data).group.name : ''
                    }}</span>
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.LIKE_POST">
                    <span class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span>
                    đã thích bài viết của bạn trong <span
                      class="text-300-medium">{{
                      detectData(notification.data).group ? detectData(notification.data).group.name : ''
                    }}</span>
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.COMMENT_POST">
                    <template
                        v-if="detectData(notification.data).created_by && detectData(notification.data).created_by.id != user.id">
                      <span class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span> đã bình
                      luận bài viết của
                      <span class="text-300-medium">{{ userName(detectData(notification.data).created_by) }}</span>
                      trong
                      <span class="text-300-medium">{{
                          detectData(notification.data).group ? detectData(notification.data).group.name : ''
                        }}</span>
                    </template>
                    <template v-else>
                      <span class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span> đã bình
                      luận bài viết của bạn trong
                      <span
                          class="text-300-medium">{{
                          detectData(notification.data).group ? detectData(notification.data).group.name : ''
                        }}</span>
                    </template>
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.CHAT_JOIN_REQUEST">
                    <span class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span>
                    yêu cầu tham gia nhóm chat
                    <span class="text-300-medium">{{ chatGroupName(detectData(notification.data)) }}</span>
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.CHAT_JOIN_APPROVED">
                    Bạn đã được <span class="text-300-medium">{{ userName(detectData(notification.data).user) }}</span>
                    phê duyệt vào nhóm chat
                    <span class="text-300-medium">{{ chatGroupName(detectData(notification.data)) }}</span>
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.CHAT_JOIN_REJECTED">
                    Yêu cầu tham gia nhóm chat
                    <span class="text-300-medium">{{ chatGroupName(detectData(notification.data)) }}</span>
                    đã bị từ chối
                  </template>
                  <template v-else-if="notification.type == NOTIFICATION_TYPE.SYSTEM">
                    <span class="text-300-medium">{{ detectData(notification.data).title || 'Thông báo hệ thống' }}</span>
                  </template>
                  <template v-else>
                    {{ fallbackNotificationText(notification) }}
                  </template>
                  <div class="create-time mt-5px text-200-default">{{ fromNow(notification.created_at) }}</div>
                </div>
              </md-list-item>
            </router-link>
          </div>
        </div>
      </vue-loadmore>
    </div>
  </div>
</template>
<script>
import {NOTIFICATION_TYPE} from "../../../../const/const";
import NotificationService from "../../../../store/services/NotificationService";
import ImageTemplate from "../../../../components/ImageTemplate";
import { notificationAvatarName, notificationAvatarUrl } from "../../../../helper/notificationAvatar";
import {
  filterTopbarNotifications,
  isTopbarNotificationType,
} from "../../../../helper/notificationTopbar";
import moment from "moment";

export default {
  name: "notification-sidebar",
  components: {
    ImageTemplate,
  },
  mounted() {
    window.addEventListener("storage", this.storageListener);
  },
  created() {
    this.getUnreadCount()
    this.getNotifications()
  },
  destroyed() {
    window.removeEventListener("storage", this.storageListener);
  },
  data() {
    return {
      user: this.$store.state.auth.user,
      unCountRead: 0,
      notifications: [],
      finished: false,
      params: {
        page: 1,
        per_page: 20,
      },
      last_page: 1,
      NOTIFICATION_TYPE: NOTIFICATION_TYPE,
      tabActive: 1,
      isLoading: false,
    }
  },
  methods: {
    getUnreadCount() {
      NotificationService.getUnreadCount().then(res => {
        if (res.data) {
          this.unCountRead = res.data.count;
          this.$store.commit("updateUnCountRead", this.unCountRead)
        }
      });
    },

    getNotifications(loadMore = false) {
      this.isLoading = true;
      let params = {...this.params};
      if (this.tabActive === 2) {
        params.has_read = 0;
      }
      NotificationService.getNotifications(params).then(res => {
        this.isLoading = false;
        if (res) {
          this.last_page = res.meta.last_page
          const rows = filterTopbarNotifications(res.data);
          if (loadMore) {
            this.notifications = this.notifications.concat(rows)
          } else {
            this.notifications = rows;
          }
        }
      });
    },

    onRefresh(done) {
      this.notifications = [];
      this.params.page = 1;
      this.finished = false;
      this.getNotifications();
      done();
    },

    onLoad(done) {
      if (this.params.page < this.last_page) {
        this.params.page++
        this.getNotifications(true);
      } else {
        this.finished = true;
      }
      done();
    },

    fromNow(date) {
      return moment(date).locale("vi").fromNow();
    },

    detectData(data) {
      if (!data) return {};
      if (typeof data === "object") return data;
      try {
        return JSON.parse(data);
      } catch (e) {
        return {};
      }
    },

    userName(user) {
      if (!user) return "Ai đó";
      return user.name || user.fullname || user.username || "Ai đó";
    },

    chatGroupName(data) {
      if (!data) return "nhóm chat";
      const group = data.chat_group || data.group;
      return group && group.name ? group.name : "nhóm chat";
    },

    fallbackNotificationText(notification) {
      const data = this.detectData(notification.data);
      const actor = this.userName(data.user);
      const groupName = this.chatGroupName(data);
      if (data.user && data.chat_group) {
        return `${actor} có hoạt động mới trong nhóm chat ${groupName}`;
      }
      return "Bạn có thông báo mới";
    },

    notificationAvatarImage(notification) {
      return notificationAvatarUrl(notification);
    },

    notificationAvatarLabel(notification) {
      return notificationAvatarName(notification) || this.userName(this.detectData(notification.data).user);
    },

    onClickNotification(notification) {
      if (!notification.is_read) {
        NotificationService.readNotifications(notification.id).then(res => {
        });
        notification.is_read = true;
        this.unCountRead--
        this.$store.commit("updateUnCountRead", this.unCountRead);
      }
    },
    reloadMessengerFromNotification(notification) {
      const url = String((notification && notification.url) || '');
      const m = url.match(/\/messenger\/(\d+)/);
      if (m) {
        this.$root.$emit('messenger:reload-conversation', m[1]);
      }
    },

    storageListener() {
      let firebaseMessage = JSON.parse(localStorage.getItem("firebase_message"));
      let createCategory = JSON.parse(localStorage.getItem("create_category"));
      if (firebaseMessage != null) {
        localStorage.removeItem("firebase_message");
        if (!isTopbarNotificationType(firebaseMessage.type)) {
          return;
        }
        firebaseMessage.is_read = false
        const nextId = this.notifications.length > 0 ? this.notifications[0].id + 1 : Date.now();
        firebaseMessage.id = nextId;
        this.unCountRead++;
        this.$store.commit("updateUnCountRead", this.unCountRead);
        this.notifications = [firebaseMessage].concat(this.notifications);
      }
      if (createCategory != null) {
        this.isCategory = true
        this.categories = createCategory
        localStorage.removeItem("create_category")
        this.getCategories()
      }
    },
    chosenTab(tab) {
      this.refreshParams();
      this.tabActive = tab;
      this.getNotifications();
    },
    readAllNotification() {
      NotificationService.readAllNotification().then(res => {
        if (res) {
          this.refreshParams();
          this.getNotifications();
          this.$store.commit("updateUnCountRead", 0);
          this.$refs.readAllBtn.click();
          const topbarNotificationBtn = document.getElementById("app-topbar-notification-btn");
          if (topbarNotificationBtn) topbarNotificationBtn.click();
        }
      });
    },
    refreshParams() {
      this.params = {
        page: 1,
        per_page: 20,
      };
    }
  },
};
</script>
<style lang="scss">
.notification-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 15px;

  .title-sidebar {
    margin: 10px 0;
    flex: 1;
    min-width: 0;
  }
}

.notification-more-btn-wrap {
  flex-shrink: 0;
  position: relative;
}

.notification-more-btn {
  border: none;
  background: #f5f6ff;
  border-radius: 6px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  color: #596073;

  &:hover {
    background: #e8ebff;
  }
}

.notification-avatar {
  width: 40px !important;
  height: 40px !important;
}

.notification-sidebar-content {
  height: calc(100vh - 140px);
  max-height: calc(100vh - 140px);
  overflow: auto;
  padding-left: 5px !important;
}

.app-topbar-notification-content .notification-sidebar-content {
  height: 70vh !important;
  max-height: 70vh !important;
}

.notification {
  .create-time {
    color: #0066ff;
    font-weight: 500;
  }

  .is_read {
    .message {
      opacity: 0.8;
      white-space: break-spaces;

      .create-time {
        color: #1f1f1f;
        font-weight: 400;
      }
    }
  }

  .md-list-item-content {
    align-items: start;
    padding: 5px !important;

    .read-badge {
      margin-right: 5px;

      .md-avatar {
        width: 40px;
        min-width: 40px;
        height: 40px;
      }

      .md-badge {
        top: inherit !important;
        width: 10px;
        height: 10px;
        background-color: #0066ff !important;
        position: absolute !important;
      }
    }

    .md-list-item-text {
      white-space: initial;
    }

    .message {
      white-space: break-spaces;
    }
  }

  .router-link-active {
    li {
      background-color: #FFEB7D !important;
    }

    .message {
      color: black;
    }
  }
}
</style>
